<div class="row align-items-center justify-content-start" [ngClass]="body.type">
  <div class="col-auto">
    @if (body.type === 'success') {

    <svg width="24" height="24" viewBox="0 0 24 24">
      <path
        d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z"
      />
    </svg>

    } @if (body.type !== 'success') {

    <svg width="24" height="24" viewBox="0 0 24 24">
      <path
        d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z"
      />
    </svg>

    }
  </div>
  <div class="col text-wrap">
    <strong>{{ body.msg }}</strong>
  </div>
  <div class="col-auto text-end">
    <svg
      (click)="close()"
      class="close-btn"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
      />
    </svg>
  </div>
</div>
